<div *ngIf="showError" class="container alert alert-danger" id="ValidationErrorMsg">
    <div class="row">
        <span class="col-12" role="alert" aria-label="Error Message" aria-live="assertive"> Error has Occured</span>
        <!-- <span class="col-12" role="alert" aria-label="Error Message" aria-live="assertive">{{showErrorMsg}}</span> -->
    </div>
</div>
<div *ngIf="infoAlert" class="container alert alert-info" id="ValidationErrorMsg">
    <div class="row">
        <span class="col-12" role="alert" aria-label="info message" aria-live="assertive">Reset Completed</span>
    </div>
</div>
<div class="container" id="loaForm">
    <div *ngIf="!showDiv">
        <!-- <div *ngIf="false"> -->
        <div class="container-sm">
            <div class="row my-2" id="title-info">
                <div class="info">
                    <span class="info-sapn" #alertText role="alert" aria-live="assertive"></span>
                </div>
                <!-- <p role="doc-acknowledgments" hidden>This application adopts global standards in digital accessibility,
                    including
                    W3C WCAG (Web Content Accessibility Guidelines). Please read <a id="accessibilityId1"
                        target="_blank" role="link" aria-label="TCS' Accessibility Commitment"
                        href="https://www.tcs.com/who-we-are/diversity-equity-inclusion/tcs-accessibility-commitment"
                        tabindex="1">TCS' Accessibility Commitment</a> for the same.</p> -->
            </div>
        </div>


        <!-- FORM REWRITE ------   START -->
        <div class="container-sm mb-3 pt-1 containerDiv">
            <div class="row">
                <h2 class="fs-6 text">Enter Your details:</h2>
            </div>
            <div class="row">
                <div class="col minWidth">
                    <div class="mb-2">
                        <label for="Namee" class="form-label">Name<span class="require">*</span></label>
                        <input type="text" [(ngModel)]="obj.name" class="form-control" id="Namee"
                            placeholder="Enter your name" aria-required="true" (focus)="onFocusAlert('nameeError')" (blur)="onUnfocusAlert('nameeError')">
                        <div class="errorMsg">
                            <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                                id="nameeError" hidden></p>
                        </div>
                    </div>
                </div>
                <div class="col minWidth">
                    <div class="mb-2">
                        <label for="CompanyInputId" class="form-label">Company/ Organization<span
                                class="require">*</span></label>
                        <input [(ngModel)]="obj.company" id="CompanyInputId" type="text" class="form-control"
                            placeholder="Enter your company/ organisation" aria-required="true" aria-invalid="false"
                            (focus)="onFocusAlert('companyInputIdError')"  (blur)="onUnfocusAlert('companyInputIdError')">
                        <div class="errorMsg">
                            <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                                id="companyInputIdError" hidden></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col mb-2 minWidth">
                    <label for="MailId" class="form-label">Official Mail ID<span class="require">*</span></label>
                    <input [(ngModel)]="obj.emailId" id="MailId" class="form-control" type="email"
                        placeholder="Enter your email" aria-required="true" (focus)="onFocusAlert('mailIdError')"  (blur)="onUnfocusAlert('mailIdError')">
                    <div class="errorMsg">
                        <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive" id="mailIdError"
                            hidden></p>
                    </div>
                </div>
                <div class="col mb-2 minWidth">
                    <div class="row">
                        <div class="col phoneMinWidth marginBottom">
                            <label for="CountryInputId" class="form-label">Country Code<span
                                    class="require">*</span></label>
                            <input [(ngModel)]="obj.countryCode" class="form-control" id="CountryInputId" type="text"
                                placeholder="Enter your Country code" aria-required="true"
                                (focus)="onFocusAlert('countryInputIdError')"  (blur)="onUnfocusAlert('countryInputIdError')">
                            <div class="errorMsg">
                                <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                                    id="countryInputIdError" hidden></p>
                            </div>
                        </div>
                        <div class="col phoneMinWidth">
                            <label for="PhoneNoInputId" class="form-label">Phone Number<span
                                    class="require">*</span></label>
                            <input [(ngModel)]="obj.phoneNo" id="PhoneNoInputId" type="text" placeholder="Enter your Phone number"
                                class="form-control" aria-required="true" (focus)="onFocusAlert('phoneNoInputIdError')"  (blur)="onUnfocusAlert('phoneNoInputIdError')">
                            <div class="errorMsg">
                                <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                                    id="phoneNoInputIdError" hidden></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-sm mb-3 pt-1 containerDiv">
            <div class="row">
                <h2 class="fs-6 text">Enter LOA details:</h2>
            </div>
            <div class="row">
                <div class="col mb-2 minWidth">
                    <label for="LoaInputId" class="form-label">Letter of Authority ID<span class="require">*</span></label>
                    <input [(ngModel)]="obj.loaId" class="form-control" id="LoaInputId" type="text"
                        placeholder="Enter Letter of Authority ID" aria-required="true" (focus)="onFocusAlert('loaInputIdError')"  (blur)="onUnfocusAlert('loaInputIdError')">
                    <div class="errorMsg">
                        <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                            id="loaInputIdError" hidden></p>
                    </div>
                </div>
                <div class="col mb-2 minWidth">
                    <label for="LoaHolderInputId" class="form-label">Name of Letter of Authority Holder<span
                            class="require">*</span></label>
                    <input [(ngModel)]="obj.loaHolderName" class="form-control" id="LoaHolderInputId" type="text"
                        placeholder=" Enter Name of Letter of Authority Holder" aria-required="true"
                        (focus)="onFocusAlert('loaHolderInputIdError')"  (blur)="onUnfocusAlert('loaHolderInputIdError')">
                    <div class="errorMsg">
                        <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                            id="loaHolderInputIdError" hidden></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-sm mb-3">
            <div class="row">
                <div class="col customFlex">
                    <label for="ExampleFormControlTextarea1">Reason for Validating<span class="require">*</span></label>
                    <div id="reasonwordcount" aria-live="polite"> {{obj.reasonForValidating.length}} of 600</div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <textarea [(ngModel)]="obj.reasonForValidating"
                        (focus)="screenReader(obj.reasonForValidating.length)" class="form-control"
                        id="ExampleFormControlTextarea1" rows="3" maxlength="600" contenteditable="true"
                        aria-required="true" aria-describedby="reasonwordcount" aria-multiline="true"
                        (focus)="onFocusAlert('exampleFormControlTextarea1Error')"  (blur)="onUnfocusAlert('exampleFormControlTextarea1Error')"></textarea>
                    <div class="errorMsg">
                        <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                            id="exampleFormControlTextarea1Error" hidden></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-sm mb-3 pt-1 containerDiv">
            <div class="row">
                <div class="col mb-3 minWidth">
                    <div class="row">
                        <div class="col captchaInfo">
                            Captcha letters are case sensitive
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-sm-4 customCaptchaDiv">
                            <div class="disableSelection me-4" onmousedown="onDown()" onkeydown="onDown()"
                                id="imgInput-div">
                                <img [src]="image" class="img-responsive" alt="captcha text" />
                            </div>
                            <div class="">
                                <span class="tooltip-container">
                                    <button class="btn captcha-refresh-b row tooltip-target" (click)="captcha()" role="button"
                                        aria-label="Captcha Refresh" data-bs-toggle="tooltip"
                                        data-bs-placement="bottom">
                                        <img id="imgInput-img" src="assets/images/refresh.png" alt="captcha refresh" />
                                    </button>
                                    <div class="tooltip-content">Captcha Refresh Button</div>
                                </span>
                                <span class="tooltip-container">
                                    <button class="bi bi-volume-up audioCaptcha row" role="button"
                                    aria-label="Audio Captcha" (click)="speak('start')"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom"></button>
                                    <div class="tooltip-content rightTC">Audio Captcha Button</div>
                                </span>
                                <!-- <button class="bi bi-volume-up audioCaptcha row" role="button"
                                    aria-label="Audio Captcha" (click)="speak('start')" title="Audio Captcha Button"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom"></button> -->

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col mb-3 minWidth">
                    <label for="EnterCaptchaInputId" class="form-label">Enter Captcha<span
                            class="require">*</span></label>
                    <input [(ngModel)]="obj.enterCaptcha" class="form-control" id="EnterCaptchaInputId" type="text"
                        placeholder="Enter Captcha" aria-required="true"
                        (focus)="onFocusAlert('enterCaptchaInputIdError')"  (blur)="onUnfocusAlert('enterCaptchaInputIdError')">
                    <div class="errorMsg">
                        <p class="text-danger error-p" aria-label="Error Message" aria-live="assertive"
                            id="enterCaptchaInputIdError" hidden></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-sm mb-3">
            <div class="row">
                <div class="col d-flex flex-wrap w-100">
                    <button type="button" class="btn btn-primary mb-2 validateBtn" (click)="ValidateForm()"
                        role="button" aria-label="Validate">Validate</button>
                    <button type="button" class="btn btn-outline-dark ms-3 mb-2" (click)="ResetForm()"
                        id="btn-reset-btn" role="button" aria-label="Reset">Reset</button>
                </div>
            </div>
        </div>
        <!-- FORM REWRITE ------   END -->

        <div class="container-sm">
            <div class="row" id="accessibilityStatement">
                <p class="col-12" role="doc-acknowledgments">Your information will be retained for TCS internal purpose
                    and will not be
                    used for any commercial
                    purpose. Please read our 
                    <span class="tooltip-container blockImp">
                    <a id="privacyNoticeId1" target="_blank" role="link"
                        aria-label="Privacy Notice"
                        href="https://www.tcs.com/who-we-are/legal/tcs-privacy-notice/">Privacy
                        Notice</a> 
                    <div class="tooltip-content tooltip-contentPrivacy">On clicking this, you will be redirected to https://www.tcs.com/</div>
                     </span>    
                    for the same.</p>
            </div>
        </div>


    </div>



</div>

<div *ngIf="showDiv" class="container" id="successForm">
    <!-- <div id="successForm" class="container"> -->


    <div class="container-sm mt-2" id="successForm-info">
        <p role="alert" aria-label="Form Successfully verified greet">Thank you for validating Letter Of
            Authority (LOA). Please find below the details of LOA Id entered by
            you.</p>
    </div>

    <div class="container-sm  mb-3 py-1 containerDiv" id="successForm-div">
        <div class="row" id="successForm-div-div">
            <h2 role="heading" class="fs-6 text">LOA Details:</h2>
        </div>
        <div class="row">
            <div class="col">
                <div class="table-responsive fs-2 text" id="successForm-divTable">
                    <table class="table table-bordered" id="successForm-divTable-table" role="table">
                        <tbody aria-label="Table body">
                            <tr class="successTr">
                                <th scope="row">LOA Id</th>
                                <td scope="col">{{obj.loaId}}</td>
                                <!-- <td>LOA/GAW/2019-2020/9VIFOT</td> -->
                            </tr>


                            <tr class="successTr">
                                <th scope="row">Name of LOA Holder</th>
                                <td>{{obj.loaHolderName}}</td>
                                <!-- <td>Sumit Salvi</td> -->

                            </tr>
                            <tr class="successTr">
                                <th scope="row">LOA Status</th>
                                <td>{{resultDto.isLOAValid}}</td>
                                <!-- <td>Valid</td> -->

                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-1" id="btn-back-second">
        <div class="col-sm-2">
            <div id="btn-back" [ngClass]="{'btn-black-height':showDiv}">
                <button type="button" class="btn btn-primary" (click)="back()" tabindex="1">Back</button>
            </div>


        </div>
    </div>
</div>



<!-- Modal -->
<div class="modal" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    [ngStyle]="{display:privacyNotice}">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Privacy Notice for the Letter of Authority Validation
                    Site</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close Symbol"
                    (click)="closePrivacyModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <object data="assets/images/LOA Validation Site - Privacy Statement.pdf" id="model-body-object">TCS
                    LOA Validation Privacy Policy</object>
            </div>

        </div>
    </div>
</div>